import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { Reveal, SectionHeader } from "./Shared";

const METRICS = [
  { label: "Win Rate (YTD)", value: "86.4%", sub: "Verified desk record" },
  { label: "Avg Risk : Reward", value: "1 : 2 – 3", sub: "Strict stop-loss ratio" },
  { label: "Monthly Profits", value: "RM 3.4M", sub: "Generated in July 2026" },
  { label: "Active Traders", value: "9,284", sub: "Malaysia & Singapore" },
];

const PROFITS = [
  { m: "Aug", v: 1.3 },
  { m: "Sep", v: 1.9 },
  { m: "Oct", v: 1.6 },
  { m: "Nov", v: 2.2 },
  { m: "Dec", v: 1.8 },
  { m: "Jan", v: 2.6 },
  { m: "Feb", v: 2.3 },
  { m: "Mar", v: 2.9 },
  { m: "Apr", v: 2.5 },
  { m: "May", v: 3.2 },
  { m: "Jun", v: 2.8 },
  { m: "Jul", v: 3.4 },
];

export default function Performance() {
  return (
    <section id="performance" data-testid="performance-section" className="py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Performance"
          title="Numbers that answer before you ask."
          sub="Monthly profits generated for members, in RM millions — a desk track record built since 2008."
        />

        <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {METRICS.map((m, idx) => (
            <Reveal key={m.label} delay={idx * 0.08}>
              <div data-testid={`metric-card-${idx}`} className="rounded-xl border border-line bg-surface p-5 md:p-6">
                <p className="font-mono text-2xl font-bold text-alpha md:text-3xl">{m.value}</p>
                <p className="mt-2 font-display text-sm font-bold text-slate-200">{m.label}</p>
                <p className="mt-1 font-mono text-[10px] text-slate-500">{m.sub}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-8 rounded-2xl border border-line bg-surface p-5 md:p-8">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="font-display text-lg font-bold text-slate-100">Profits Generated</p>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">RM Million / Month &middot; Aug 2025 — Jul 2026</p>
            </div>
            <div className="mt-6 h-72 w-full" data-testid="performance-chart">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={PROFITS} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
                  <defs>
                    <linearGradient id="alphaFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#00E676" stopOpacity={0.35} />
                      <stop offset="100%" stopColor="#00E676" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid stroke="#1E2A3A" strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="m" stroke="#475569" tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }} tickLine={false} axisLine={false} />
                  <YAxis stroke="#475569" tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}M`} />
                  <Tooltip
                    contentStyle={{ background: "#0E141D", border: "1px solid #1E2A3A", borderRadius: 12, fontFamily: "JetBrains Mono", fontSize: 12 }}
                    labelStyle={{ color: "#94A3B8" }}
                    formatter={(v) => [`RM ${v} Million`, "Profits generated"]}
                  />
                  <Area type="monotone" dataKey="v" stroke="#00E676" strokeWidth={2.5} fill="url(#alphaFill)" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
            <p className="mt-4 font-mono text-[10px] text-slate-600">
              Desk-reported figures as on July 2026. Past results do not guarantee future returns.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
